// @ts-check
/** Local subscriptions connect simulation events to presentation without a browser dependency. */
export function createEvents() {
  /** @type {Set<import('./types.js').EventSink>} */
  const listeners = new Set();
  return {
    /** @param {import('./types.js').EventSink} listener */
    subscribe(listener) { listeners.add(listener); return () => { listeners.delete(listener); }; },
    /** @param {import('./types.js').GameEvent} event */
    emit(event) { for (const listener of listeners) listener(event); },
    clear() { listeners.clear(); },
    get size() { return listeners.size; },
  };
}
